import { render, staticRenderFns } from "./TransferItinerary.vue?vue&type=template&id=7845d30a&"
import script from "./TransferItinerary.vue?vue&type=script&lang=js&"
export * from "./TransferItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports